import { createSlice } from "@reduxjs/toolkit";
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

// Static dropdown values for various dropdowns

const GenderOptions = [
  { value: '1', label: currentLang?.DropDown?.Male },
  { value: '2', label: currentLang?.DropDown?.Female },
  { value: '3', label: currentLang?.DropDown?.Unknown },
];

const MaritalStatusOptions = [
  { value: 1, label: currentLang?.DropDown?.Single },
  { value: 2, label: currentLang?.DropDown?.Divorced },
  { value: 3, label: currentLang?.DropDown?.Separated },
  { value: 4, label: currentLang?.DropDown?.Married },
  { value: 5, label: currentLang?.DropDown?.Living_with_the_parent_of_your_children },
];

const YesorNoOptions = [
  { value: 1, label: currentLang?.DropDown?.Yes },
  { value: 0, label: currentLang?.DropDown?.No },
];

const IncomeTypeOptions = [
  { value: 1, label: currentLang?.DropDown?.week },
  { value: 2, label: currentLang?.DropDown?.two_weeks },
  { value: 3, label: currentLang?.DropDown?.month },
  { value: 4, label: currentLang?.DropDown?.year },
];

const FrequencyTYpeOptions = [
  { value: 1, label: currentLang?.DropDown?.week },
  { value: 2, label: currentLang?.DropDown?.month },
];

// Request Page Legal Research Form

const WhoSendOptions = [
  { value: 1, label: currentLang?.DropDown?.Local_Law_Enforcement_Agency },
  { value: 2, label: currentLang?.DropDown?.US_Marshall },
  { value: 3, label: currentLang?.DropDown?.ICE_INS },
  { value: 4, label: currentLang?.DropDown?.Georgia_DOC },
  { value: 5, label: currentLang?.DropDown?.Federal_Bureau_of_Prisons },
  { value: 6, label: currentLang?.DropDown?.Other },
];

const ConvictedOptions = [
  { value: 1, label: currentLang?.DropDown?.Yes },
  { value: 2, label: currentLang?.DropDown?.No },
];

const ResearchingOptions = [
  { value: 1, label: currentLang?.DropDown?.My_Current_charges},
  { value: 2, label: currentLang?.DropDown?.An_Appeal_I_am_pursuing},
  { value: 3, label: currentLang?.DropDown?.A_Habeas_Corpus_action },
  { value: 4, label: currentLang?.DropDown?.A_Civil_Rights_Issue},
  { value: 5, label: currentLang?.DropDown?.A_Condition_of_Confinement_Concern },
  { value: 6, label: currentLang?.DropDown?.A_Civil_Issue_Such_as_child_custody },
  { value: 7, label: currentLang?.DropDown?.Some_other_legal_matter },
];

const LawyerTypeOptions = [
  { value: 0, label: currentLang?.DropDown?.N_A },
  { value: 1, label: currentLang?.DropDown?.A_Court_Appointed_Public_Defender },
  { value: 2, label: currentLang?.DropDown?.A_Private_Attorney },
];

const JurisdictionOptions = [
  { value: 1, label: currentLang?.DropDown?.Georgia_Criminal },
  { value: 2, label: currentLang?.DropDown?.Georgia_Civil },
  { value: 3, label: currentLang?.DropDown?.Federal_Criminal },
  { value: 4, label: currentLang?.DropDown?.Federal_Civil },
  { value: 5, label: currentLang?.DropDown?.Administrative },
  { value: 6, label: currentLang?.DropDown?.Immigration },
  { value: 7, label: currentLang?.DropDown?.Other_State },
];


// create slice
const name = "dropdownOptions";
const initialState = createInitialState();

const slice = createSlice({
  name,
  initialState,
  reducers: {},
});

// exports
export const dropdownActions = {
  ...slice.actions,
};
export const dropdownReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    WhoSendOptions: WhoSendOptions,
    ConvictedOptions: ConvictedOptions,
    ResearchingOptions: ResearchingOptions,
    JurisdictionOptions: JurisdictionOptions,
    LawyerTypeOptions: LawyerTypeOptions,
    GenderOptions: GenderOptions,
    MaritalStatusOptions: MaritalStatusOptions,
    YesorNoOptions: YesorNoOptions,
    IncomeTypeOptions: IncomeTypeOptions,
    FrequencyTYpeOptions: FrequencyTYpeOptions
  };
}
